import { render, staticRenderFns } from "./GhostButton.vue?vue&type=template&id=1b214198&"
import script from "./GhostButton.vue?vue&type=script&lang=js&"
export * from "./GhostButton.vue?vue&type=script&lang=js&"
import style0 from "./GhostButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports